var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',[_c('router-link',{attrs:{"to":"/"}},[_vm._v(" "+_vm._s(_vm.mainBudget.when)+" "+_vm._s(_vm.mainBudget.type)+" Budget ")]),_c('label',{staticClass:"sr-only",attrs:{"for":"dept-select"}},[_vm._v("Select a Department")]),_c('SelectDepartment',{attrs:{"departments":_vm.departments,"id":"dept-select"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }